import { TaskCard } from './TaskCard';
import { CompactTaskList } from './CompactTaskList';

/**
 * Integrated task group for dashboard view
 * Combines stat header with task list
 */
export function IntegratedTaskGroup({ groupName, title, icon, count, tasks, locations, users, onSelectTask, variant, colorClass }) {
  const isEmpty = tasks.length === 0;
  const compact = variant === 'compact';

  // Check for unresolved issues in completed group
  const hasUnresolvedIssues = groupName === 'completed' &&
                               tasks.some(task => task.status === 'completed-with-issues');

  return (
    <div className={`integrated-task-card ${colorClass}`}>
      {/* Stat Header — static, groups are always open */}
      <div className="integrated-stat-header">
        <div className="stat-icon"><i className={icon}></i></div>
        <div className="stat-content">
          <h3 className={hasUnresolvedIssues ? 'with-issues' : ''}>{count}</h3>
          <p>{title}</p>
        </div>
      </div>

      {/* Task Content — always open, scrolls internally */}
      {!isEmpty && (
        <div className="integrated-task-content">
          {compact ? (
            <CompactTaskList
              tasks={tasks}
              onSelectTask={onSelectTask}
            />
          ) : (
            <div className="task-list-expanded">
              {tasks.map(task => (
                <TaskCard
                  key={task.id}
                  task={task}
                  locations={locations}
                  users={users}
                  onSelect={() => onSelectTask(task)}
                />
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  );
}
